import { render } from "./SkychartObjectLegend.vue?vue&type=template&id=7256c840"
import script from "./SkychartObjectLegend.vue?vue&type=script&lang=js"
export * from "./SkychartObjectLegend.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__